import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Pensás en ciertas personas aunque no quieras y no sabés cómo soltar ese loop', 'Te acostás cansada y tu mente empieza a repasar todo lo que salió mal', 'Trabajaste el mismo patrón mil veces y sigue apareciendo', 'Sentís que cargás con emociones que no son tuyas pero no podés identificar cuáles', 'Tomás decisiones desde el miedo o la culpa sin darte cuenta', 'Fin de semana agotada, lunes volvés a empezar el mismo ciclo interno'];
  return <Section className="max-w-4xl" data-id="element-198">
      <div className="text-center mb-12" data-id="element-199">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-200">
          ¿Cuánto tiempo más vas a cargar con eso?
        </h2>
        <p className="text-lg text-brand-text/80 mb-4" data-id="element-201">
          Sos una mujer que trabaja su mundo interno. Que lee, que busca, que se
          esfuerza.
        </p>
        <p className="text-lg text-brand-text/80 mb-4" data-id="element-202">
          Pero nadie te dijo que ibas a pasar años yendo a terapia sin que algo
          termine de cerrarse. Meditando sin que el ruido mental pare de verdad.
          Leyendo libros de autoayuda que te inspiran tres días y después todo
          vuelve igual.
        </p>
        <p className="text-xl font-medium text-brand-gold mt-6" data-id="element-203">
          No es falta de ganas. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12" data-id="element-204">
        <h3 className="text-xl font-medium mb-6 flex items-center text-brand-text/90" data-id="element-205">
          <X className="w-6 h-6 text-red-400 mr-2" data-id="element-206" /> Esto te resulta familiar:
        </h3>
        <ul className="space-y-4" data-id="element-207">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-208">
              <X className="w-5 h-5 text-red-400/70 mr-3 mt-0.5 shrink-0" data-id="element-209" />
              <span className="text-brand-text/80 leading-relaxed" data-id="element-210">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-211">
        <h3 className="text-2xl md:text-3xl font-serif font-bold gold-gradient-text" data-id="element-212">
          ¿Y si este fuera el último día que seguís igual?
        </h3>
      </div>
    </Section>;
};